export const BERLIN_TIMEZONE = 'Europe/Berlin';
